import Icon from '../components/Icon.vue'

Icon.register({"reply":{"width":1792,"height":1792,"paths":[{"d":"M1792 1120q0 166-127 451-3 7-10.5 24t-13.5 30-13 22q-12 17-28 17-15 0-23.5-10t-8.5-25q0-9 2.5-26.5t2.5-23.5q5-68 5-123 0-101-17.5-181t-48.5-138.5-80-101-105.5-69.5-133-42.5-154-21.5-175.5-6h-224v256q0 26-19 45t-45 19-45-19l-512-512q-19-19-19-45t19-45l512-512q19-19 45-19t45 19 19 45v256h224q713 0 875 403 53 134 53 333z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/reply.js
// module id = bhVa
// module chunks = 0